import React from "react";
import { NavLink } from "react-router-dom";

import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import { HSeparator } from "components/separator/Separator";
import DefaultAuth from "layouts/auth/Default";
// Assets
import { ChevronDownIcon } from "@chakra-ui/icons";
import { apiurl } from "APIURL";
import illustration from "assets/img/auth/auth.jpg";
import axios from "axios";
import { FcGoogle } from "react-icons/fc";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";

function Signup() {
  // Chakra color mode
  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = "gray.400";
  const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
  const textColorBrand = useColorModeValue("brand.500", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");
  const googleBg = useColorModeValue("secondaryGray.300", "whiteAlpha.200");
  const googleText = useColorModeValue("navy.700", "white");
  const { colorMode, toggleColorMode } = useColorMode();
  // Chakra Color Mode
  const navbarIcon = useColorModeValue("gray.400", "white");
  let menuBg = useColorModeValue("white", "navy.800");
  const textColor1 = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand1 = useColorModeValue("brand.700", "brand.400");
  const ethColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const ethBg = useColorModeValue("secondaryGray.300", "navy.900");
  const ethBox = useColorModeValue("white", "navy.800");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  const googleHover = useColorModeValue(
    { bg: "gray.200" },
    { bg: "whiteAlpha.300" }
  );
  const googleActive = useColorModeValue(
    { bg: "secondaryGray.300" },
    { bg: "whiteAlpha.200" }
  );
  const [show, setShow] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [name, setName] = React.useState("");
  const [surname, setSurname] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [matricule, setMatricule] = React.useState("");
  const [matriculeShwn, setMatriculeShwn] = React.useState(false);
  const [role, setRole] = React.useState("2");
  const handleClick = () => setShow(!show);
  const handleSubmit = async (
    event: React.FormEvent,
    email: string,
    password: string,
    name: string,
    surname: string,
    phoneNumber: string
  ) => {
    event.preventDefault();
    const response = await axios.post(`${apiurl}/auth/signup`, {
      email,
      password,
      name,
      surname,
      matricule: parseInt(matricule),
      phoneNumber: parseInt(phoneNumber),
      isVerified: false,
      role: {
        connect: {
          id: parseInt(role),
        },
      },
    });
    console.log(response.data);
  };
  return (
    <DefaultAuth illustrationBackground={illustration} image={illustration}>
      <Flex
        maxW={{ base: "100%", md: "max-content" }}
        w="100%"
        mx={{ base: "auto", lg: "0px" }}
        me="auto"
        h="100%"
        alignItems="start"
        justifyContent="center"
        mb={{ base: "30px", md: "60px" }}
        px={{ base: "25px", md: "0px" }}
        mt={{ base: "40px", md: "14vh" }}
        flexDirection="column"
      >
        <Box me="auto">
          <Heading color={textColor} fontSize="36px" mb="10px">
            Créer un compte
          </Heading>
          {/*<Text
            mb='36px'
            ms='4px'
            color={textColorSecondary}
            fontWeight='400'
            fontSize='md'>
            Entre votre email et mot de pass pour se connecter!
          </Text>*/}
        </Box>
        <Flex
          zIndex="2"
          direction="column"
          w={{ base: "100%", md: "420px" }}
          maxW="100%"
          background="transparent"
          borderRadius="15px"
          mx={{ base: "auto", lg: "unset" }}
          me="auto"
          mb={{ base: "20px", md: "auto" }}
        >
          <Button
            fontSize="sm"
            me="0px"
            mb="26px"
            py="15px"
            h="50px"
            borderRadius="16px"
            bg={googleBg}
            color={googleText}
            fontWeight="500"
            _hover={googleHover}
            _active={googleActive}
            _focus={googleActive}
          >
            <Icon as={FcGoogle} w="20px" h="20px" me="10px" />
            Connecter avec Google
          </Button>
          <Flex align="center" mb="25px">
            <HSeparator />
            <Text color="gray.400" mx="14px">
              ou
            </Text>
            <HSeparator />
          </Flex>
          <form
            action=""
            onSubmit={(e) =>
              handleSubmit(e, email, password, name, surname, phoneNumber)
            }
          >
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Nom<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                value={name}
                onChange={(e) => setName(e.target.value)}
                isRequired={true}
                variant="auth"
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Votre nom"
                mb="24px"
                fontWeight="500"
                size="lg"
              />
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Prénom<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                value={surname}
                onChange={(e) => setSurname(e.target.value)}
                isRequired={true}
                variant="auth"
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Votre prénom"
                mb="24px"
                fontWeight="500"
                size="lg"
              />

              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Email<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                isRequired={true}
                variant="auth"
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="email"
                placeholder="mail@exemple.com"
                mb="24px"
                fontWeight="500"
                size="lg"
              />
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Numéro de téléphonee<Text color={brandStars}>*</Text>
              </FormLabel>
              <Input
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                isRequired={true}
                variant="auth"
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="tel"
                placeholder="+216 000 000 00"
                mb="24px"
                fontWeight="500"
                size="lg"
              />
              <FormLabel
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                display="flex"
              >
                Mot de passe<Text color={brandStars}>*</Text>
              </FormLabel>
              <InputGroup size="md">
                <Input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  isRequired={true}
                  fontSize="sm"
                  placeholder="Min. 8 characters"
                  mb="24px"
                  size="lg"
                  type={show ? "text" : "password"}
                  variant="auth"
                />
                <InputRightElement display="flex" alignItems="center" mt="4px">
                  <Icon
                    color={textColorSecondary}
                    _hover={{ cursor: "pointer" }}
                    as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                    onClick={handleClick}
                  />
                </InputRightElement>
              </InputGroup>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="500"
                color={textColor}
                mb="8px"
              >
                Role<Text color={brandStars}>*</Text>
              </FormLabel>
              <Menu>
                <MenuButton width={"100%"} p="0px">
                  <Text
                    ps="20px"
                    pt="16px"
                    pb="10px"
                    w="100%"
                    borderBottom="1px solid"
                    borderColor={borderColor}
                    fontSize="sm"
                    fontWeight="700"
                    color={textColor1}
                  >
                    {role === "2"
                      ? "Stagiaire"
                      : role === "3"
                      ? "Employé TT"
                      : role === "4"
                      ? "Profissionel"
                      : "Formateur"}
                  </Text>
                  <ChevronDownIcon />
                </MenuButton>
                <MenuList
                  boxShadow={shadow}
                  p="0px"
                  mt="10px"
                  borderRadius="20px"
                  bg={menuBg}
                  border="none"
                >
                  <Flex flexDirection="column" p="10px">
                    <MenuItem
                      as={Button}
                      onClick={(e) => {
                        setRole("2");
                        setMatriculeShwn(false);
                      }}
                      _hover={{ bg: "none" }}
                      _focus={{ bg: "none" }}
                      borderRadius="8px"
                      px="14px"
                    >
                      <Text fontSize="sm">Stagiaire</Text>
                    </MenuItem>
                    <MenuItem
                      as={Button}
                      onClick={(e) => {
                        setRole("3");
                        setMatriculeShwn(true);
                      }}
                      _hover={{ bg: "none" }}
                      _focus={{ bg: "none" }}
                      borderRadius="8px"
                      px="14px"
                    >
                      <Text fontSize="sm">Employé TT</Text>
                    </MenuItem>
                    <MenuItem
                      as={Button}
                      onClick={(e) => {
                        setRole("4");
                        setMatriculeShwn(false);
                      }}
                      _hover={{ bg: "none" }}
                      _focus={{ bg: "none" }}
                      borderRadius="8px"
                      px="14px"
                    >
                      <Text fontSize="sm">Profissionel</Text>
                    </MenuItem>
                    <MenuItem
                      as={Button}
                      onClick={(e) => {
                        setRole("5");
                        setMatriculeShwn(false);
                      }}
                      _hover={{ bg: "none" }}
                      _focus={{ bg: "none" }}
                      borderRadius="8px"
                      px="14px"
                    >
                      <Text fontSize="sm">Formateur</Text>
                    </MenuItem>
                  </Flex>
                </MenuList>
              </Menu>
              {matriculeShwn === true ? (
                <>
                  <FormLabel
                    display="flex"
                    ms="4px"
                    fontSize="sm"
                    fontWeight="500"
                    color={textColor}
                    mb="8px"
                  >
                    Matricule<Text color={brandStars}>*</Text>
                  </FormLabel>
                  <Input
                    value={matricule}
                    onChange={(e) => setMatricule(e.target.value)}
                    isRequired={role === "3" ? true : false}
                    variant="auth"
                    fontSize="sm"
                    ms={{ base: "0px", md: "0px" }}
                    type="tel"
                    placeholder="Matricule"
                    mb="24px"
                    fontWeight="500"
                    size="lg"
                  />
                </>
              ) : null}
              <Flex justifyContent="space-between" align="center" mb="24px">
                <FormControl display="flex" alignItems="center"></FormControl>
              </Flex>
              <Button
                type="submit"
                fontSize="sm"
                variant="brand"
                fontWeight="500"
                w="100%"
                h="50"
                mb="24px"
              >
                Créer un compte
              </Button>
            </FormControl>
          </form>
          <Flex
            flexDirection="column"
            justifyContent="center"
            alignItems="start"
            maxW="100%"
            mt="0px"
          >
            <Text color={textColorDetails} fontWeight="400" fontSize="14px">
              Déja inscrit?
              <NavLink to="/auth/sign-in">
                <Text
                  color={textColorBrand}
                  as="span"
                  ms="5px"
                  fontWeight="500"
                >
                  Connecter
                </Text>
              </NavLink>
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default Signup;
